import { render, staticRenderFns } from "./payStat.vue?vue&type=template&id=089902da&scoped=true&"
import script from "./payStat.vue?vue&type=script&lang=js&"
export * from "./payStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089902da",
  null
  
)

export default component.exports